import Phaser from 'phaser';
import { sfx } from '@/systems/sfx';
import { foretrekkerRedusertBevegelse } from '@/systems/motionPreferanser';

export function animateModalGlide(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  opts?: { offset?: number; duration?: number; spillLyd?: boolean },
): void {
  const offset = opts?.offset ?? 30;
  const duration = opts?.duration ?? 250;
  const spillLyd = opts?.spillLyd !== false;

  if (spillLyd) sfx.play('pageturn');

  const sluttY = container.y;

  if (foretrekkerRedusertBevegelse()) {
    container.y = sluttY;
    container.alpha = 1;
    container.setScale(1);
    return;
  }

  container.y = sluttY + offset;
  container.alpha = 0;
  container.setScale(0.95);

  scene.tweens.add({
    targets: container,
    y: sluttY,
    alpha: 1,
    scale: 1,
    duration,
    ease: 'Cubic.easeOut',
  });
}

export function animateModalClose(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  onComplete: () => void,
  opts?: { duration?: number; spillLyd?: boolean },
): void {
  const duration = opts?.duration ?? 200;
  if (opts?.spillLyd) sfx.play('click');
  if (foretrekkerRedusertBevegelse()) {
    onComplete();
    return;
  }
  scene.tweens.add({
    targets: container,
    alpha: 0,
    scale: 0.95,
    duration,
    ease: 'Cubic.easeIn',
    onComplete,
  });
}

export function animateFabBounce(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.GameObject,
): void {
  if (foretrekkerRedusertBevegelse()) return;
  scene.tweens.add({
    targets: target,
    scale: { from: 1.0, to: 0.86 },
    duration: 90,
    yoyo: true,
    ease: 'Back.easeOut',
  });
}

export function animateBadgePulse(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.GameObject,
): void {
  if (foretrekkerRedusertBevegelse()) return;
  scene.tweens.add({
    targets: target,
    scale: { from: 1.0, to: 1.2 },
    duration: 150,
    yoyo: true,
    ease: 'Sine.easeOut',
  });
}
